import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=7bd8f1b2&scoped=true&"
import script from "./OrderReview.vue?vue&type=script&lang=ts&"
export * from "./OrderReview.vue?vue&type=script&lang=ts&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=7bd8f1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8f1b2",
  null
  
)

export default component.exports